<template>
  <div class="uk-flex uk-flex-center">
    <div class="uk-width-large">
      <div class="uk-card uk-card-default uk-margin">
        <div class="uk-card-header uk-text-center">
          <h3 class="uk-card-title" data-cy="user-form-title">New {{ textType|capitalize }} User</h3>
        </div>
        <div class="uk-card-body">
          <user-form ref="form-user" type="new" />
        </div>
        <div class="uk-card-footer uk-text-center">
          <button class="uk-button uk-button-primary" :disabled="disabled" data-cy="user-form-btn-create" @click="create">Create</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserForm from '@/components/form/User.vue'

export default {
  name: 'ComponentUserCreate',

  components: {
    UserForm
  },

  props: {
    type: {
      type: Number,
      required: true
    },
    dentist: {
      type: String,
      required: false,
      default: null
    }
  },

  data() {
    return {
      formData: null,
      formComponent: null
    }
  },

  computed: {
    textType() {
      const types = {
        1: 'admin',
        2: 'operator',
        3: 'dentist'
      }
      return types[this.type]
    },

    disabled() {
      return this.formComponent ? !this.formComponent.observer.flags.valid : true
    }
  },

  mounted() {
    this.formComponent = this.$refs['form-user']
    this.formData = this.formComponent.form
  },

  methods: {
    async create() {
      const loader = this.$loader.show('Creating User Record')
      const valid = await this.formComponent.validate()
      let result = null

      if (valid) {
        try {
          const createUser = this.$firebaseFunctions.httpsCallable('createUser')
          const user = this.formData
          user.type = this.type

          if (this.type === 3 && this.dentist) {
            user.dentist = this.dentist
          }

          result = await createUser(user)
        } catch (error) {
          result = error
          await loader.hide(true)
          this.$uikit.notification(error, { status: 'danger' })
        }
      }

      if ((result instanceof Error !== true) && result.data.status === 'success') {
        await loader.hide()

        const modal = this.$uikit.modal.alert(`New ${this.$options.filters.capitalize(this.textType)} User was created successfully!`)
        modal.dialog.$el.setAttribute('data-cy', 'user-create-modal-success')
        modal.dialog.$el.querySelector('.uk-button-primary').setAttribute('data-cy', 'user-create-modal-success-btn')

        if (this.type === 3 && this.dentist) {
          this.$router.push({ name: 'dentist-manage', param: { id: this.dentist } })
        } else {
          this.$router.push({ name: `${this.textType}-list` })
        }
      }
    }
  }
}
</script>
